// TODO change string content to match enum name; kept it for now because it would break current content
export enum WebContentLocation {
  ProfileOverviewContent = 'account_overview_content',
  ProfileBackgroundImage = 'account_background_image',
  ProfileLogoImage = 'account_logo_image',
  ProfileOverviewSlogan = 'account_overview_slogan',
  ProfileOverviewTopContent = 'account_overview_topcontent'
}
